<template>
    <div>
        <div class="mainWrapper">
            <MainSideBarVue />

            <div class="rightContentWrapper">
                <div class="topNav">
                    <TopBarVue />
                </div>

                <div class="innerContainer">





                    <div class="theHeaderWrapper">



                        <i @click="$router.go(-1)" style="font-size: 25px; font-weight: bold; cursor: pointer;"
                            class="bi bi-arrow-left"></i>

                        <div style="margin-left: 20px;">
                            Employees
                        </div>




                    </div>

                    <div class="searchBarWrapper">

                        <input v-model="searchQuery" type="text" class="form-control theBar"
                            placeholder="Search by employee name..." />

                        <div v-if="teamStore.toolbox_talk_app && teamStore.toolbox_talk_app.features_access_type">




                            <button v-if="teamStore.toolbox_talk_app.features_access_type === 'standard_talks'"
                                @click="teamStore.goToAddNewUserView" class="button-6" role="button">
                                + Add Users
                            </button>

                            <button v-if="teamStore.toolbox_talk_app.features_access_type === 'group_talks'"
                                @click="teamStore.goToAddNewGroupTalkUserView" class="button-6" role="button">
                                + Add Users to group talk
                            </button>

                            <button v-if="teamStore.toolbox_talk_app.features_access_type === 'both'"
                                @click="teamStore.openAddingNewUsersButtonNavModal" class="button-6" role="button"
                                style="background: black; color: white;">
                                + Add New User
                            </button>


                        </div>


                    </div>




                    <div class="tableWrapper">

                        <table class="table table-hover my-custom-table">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Teams</th>
                                    <th scope="col">Safety Talks</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(employee, index) in filteredEmployees" :key="index">


                                    <td>
                                        {{ employee.name }}

                                        <div v-if="employee.role_id == 4">
                                            <span class="badge rounded-pill bg-success">
                                                Sub Manager
                                            </span>
                                        </div>

                                        <div v-if="employee.role_id == 5">


                                            <span class="badge rounded-pill bg-light" style="color: black;">
                                                Master Account Admin
                                            </span>

                                        </div>

                                        <div v-if="employee.role_id == 6">


                                            <span class="badge rounded-pill bg-light" style="color: black;">
                                                Supervisor
                                            </span>

                                        </div>
                                    </td>

                                    <td>



                                        <div v-if="employee.role_id == 3">

                                            <span v-if="employee.user_teams && employee.user_teams.length > 0" class="badge rounded-pill bg-success"
                                                style="font-size: 12px; cursor: pointer;"
                                                @click="() => { campaignStore.setCurrentUserTeams(employee.user_teams, employee); campaignStore.openShowViewUserTeamsModal(); }">


                                                View

                                            </span>

                                            <span v-else class="badge rounded-pill bg-light text-dark"
                                                style="font-size: 12px; cursor: pointer;"
                                                @click="() => { campaignStore.setCurrentUserTeams(employee.user_teams, employee); campaignStore.openShowViewUserTeamsModal(); }">


                                                No team
                                                <i class="bi bi-repeat"></i>

                                            </span>

                                            

                                        </div>




                                    </td>

                                    <td>

                                        <router-link v-if="employee.role_id == 3" :to="{
                                            name: 'ViewTalksForAEmployee',
                                            params: { uuid: employee.uuid },
                                        }">

                                            <span
                                                v-if="employee.acknowledgements && employee.acknowledgements.length > 0"
                                                class="badge rounded-pill bg-dark" style="font-size: 14px;">
                                                {{ employee.acknowledgements.length }}
                                            </span>

                                        </router-link>

                                    </td>

                                    <td>


                                        <div v-if="employee.role_id === 3">

                                            <span v-if="employee.is_active"
                                                class="badge rounded-pill bg-success activeSpan"
                                                style="cursor: pointer;"
                                                @click="teamStore.openActivateDeactiveModal(employee, 'yes_active')">Active</span>

                                            <span style="cursor: pointer;" v-else
                                                class="badge rounded-pill bg-light text-dark"
                                                @click="teamStore.openActivateDeactiveModal(employee, 'not_active')">Deactivated</span>

                                        </div>



                                    </td>

                                    <td>

                                        <i @click="teamStore.openEditUserDetailsModal(employee)" class="bi bi-pencil"
                                            style="font-size: 18px; margin-right: 20px; cursor: pointer;"></i>

                                        <i @click="() => { teamStore.setCurrentEmployee(employee); teamStore.openShowDeleteEmployeeModal(); }"
                                            style="cursor: pointer;" class="bi bi-trash"></i>


                                    </td>



                                </tr>

                            </tbody>




                        </table>






                    </div>



                    <button v-if="displayedEmployeesCount < campaignStore.employees.length"
                        class="btn btn-dark loadMoreBtn" @click="loadMoreEmp">Load more</button>


                </div>
            </div>
        </div>



        <div v-if="teamStore.showDeleteEmployeeModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">
                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Are you sure you want to delete this employee?</b>
                    </div>

                    <div>
                        <i @click="teamStore.closeShowDeleteEmployeeModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content" style="text-align: left;">




                    <p><b style="color: red;">Very Important Note:</b>
                        It's highly recommeded to download all safety talks data related to <b>{{
                            teamStore.currentEmployee.name
                            }}</b> before deleting. Once deleted this user will removed from all teams its associated
                        with
                        and lose access to <b>all apps</b> on the Safelyio platform. This data is unrecoverable.
                    </p>




                    <div>
                        <button @click="softDeleteThisEmployeeCompletely()" type="button"
                            class="btn btn-danger createBTN">
                            <b>Yes, Delete!</b>
                        </button>
                    </div>



                </div>
            </div>
        </div>

        <div v-if="campaignStore.showViewUserTeamsModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">
                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Teams</b>
                    </div>

                    <div>
                        <i @click="campaignStore.closeShowViewUserTeamsModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content" style="text-align: left;">


                    <div v-if="campaignStore.currentUserTeams.length > 0"
                        style="width: 100%; max-height: 500px; overflow-y: auto;">

                        <table class="table">

                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Team Creation Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(team, index) in campaignStore.currentUserTeams" :key="index">

                                    <td>{{ team.name }}</td>
                                    <td>{{ campaignStore.formatDate(team.created_at) }}</td>
                                </tr>

                            </tbody>
                        </table>


                    </div>

                    <div v-else>
                        <div style="margin-bottom: 20px;">Not associated with any teams.</div>

                        <button @click="campaignStore.openReAddEmployeeToTeamModal" class="btn btn-dark btn-sm"><i class="bi bi-repeat"></i> Add to Team</button>

                    </div>



                </div>
            </div>
        </div>


        <div v-if="teamStore.showActivateDeactiveModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">
                <div class="model-box-header">
                    <div style="font-size: 17px">

                        <div v-if="teamStore.activateModalType === 'yes_active'">
                            <b>Deactivate {{ teamStore.currentEmployee.name }}?</b>
                        </div>

                        <div v-if="teamStore.activateModalType === 'not_active'">
                            <b>Activate {{ teamStore.currentEmployee.name }}?</b>
                        </div>


                    </div>

                    <div>
                        <i @click="teamStore.closeActivateDeactiveModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content" style="text-align: left;">


                    <p v-if="teamStore.activateModalType === 'yes_active'"> This user will no longer receive future
                        safety talks, but all past data will remain intact.
                        You can reactivate them at any time.
                    </p>

                    <p v-if="teamStore.activateModalType === 'not_active'"> This user will now receive future safety
                        talks going forward.
                    </p>


                    <!-- {{ teamStore.currentEmployee.is_active }} -->


                    <div>
                        <button v-if="teamStore.activateModalType === 'yes_active'" type="button"
                            class="btn btn-danger createBTN" @click="teamStore.toggleActivateReactivate">
                            <b>Yes, Deactivate!</b>
                        </button>

                        <button v-if="teamStore.activateModalType === 'not_active'" type="button"
                            class="btn btn-success createBTN" @click="teamStore.toggleActivateReactivate">
                            <b>Ractivate!</b>
                        </button>
                    </div>



                </div>
            </div>
        </div>

        <div v-if="teamStore.showEditUserDetailsModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">
                <div class="model-box-header">
                    <div style="font-size: 17px">

                        <b> Edit User</b>

                    </div>

                    <div>
                        <i @click="teamStore.closeEditUserDetailsModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content" style="text-align: left;">


                    <form @submit.prevent="teamStore.updateUserDetails">


                        <div class="mb-3">
                            <label class="form-label" style="float: left;">First Name</label>
                            <input v-model="teamStore.currentEmployee.fname" type="text" class="form-control" required>
                        </div>

                        <div class="mb-3">
                            <label class="form-label" style="float: left;">Last Name</label>
                            <input v-model="teamStore.currentEmployee.lname" type="text" class="form-control" required>
                        </div>


                        <div>

                            <button type="submit" class="btn btn-dark createBTN">
                                <b>Save</b>
                            </button>
                        </div>



                    </form>



                </div>
            </div>
        </div>

        <div v-if="teamStore.showButtonNavModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">
                <div class="model-box-header">
                    <div style="font-size: 17px">



                    </div>

                    <div>
                        <i @click="teamStore.closeAddingNewUsersButtonNavModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content" style="text-align: left;">



                    <button @click="teamStore.goToAddNewUserView" class="button-6" role="button">
                        + Add users to standard talk
                    </button>

                    <br>

                    <button @click="teamStore.goToAddNewGroupTalkUserView" class="button-6" role="button">
                        + Add users to group talk
                    </button>



                </div>
            </div>
        </div>


        <div v-if="campaignStore.showReAddEmployeeToTeamModal" class="modal-overlay">

            <div class="modal-box" style="width: 700px">

                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Select Team</b>
                    </div>

                    <div>
                        <i @click="campaignStore.closeReAddEmployeeToTeamModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i> 
                    </div>
                </div>

                <div class="modal-search-box" style="padding: 12px;">

                    <input v-model="teamQuery" type="text" class="form-control titleInput"
                        placeholder="Search..." />

                </div>

                <div class="modal-content">


                <!-- {{ campaignStore.currentEmployee }} -->


                    <!-- {{ campaignStore.teamsToAddUserTo }} -->


                    <div class="innerBox">



                            <div class="talkItem" v-for="(team, index) in filteredTeams" :key="index"
                            @click="campaignStore.selectedTeamToReAddEmployee(team)"
                                >



                                <div class="talkLeft">

                                    <div class="talkTitle">


                                        {{ team.name }}


                                    </div>




                                </div>

                                <div class="talkRight">


                                    <!-- {{ team.is_checked }} -->


                                    <div v-if="team.is_checked" class="form-check form-switch">
                                        <input class="form-check-input theInputSwitch" type="checkbox"
                                            id="flexSwitchCheckDefault" checked>
                                    </div>

                                    <div v-else class="form-check form-switch">
                                        <input class="form-check-input theInputSwitch" type="checkbox"
                                            id="flexSwitchCheckDefault">
                                    </div>



                                </div>




                            </div>
              

             








                    </div>

                    <div  class="groupActionBox"
                        style="margin-top: 30px;">

                        <button v-if="campaignStore.isLoading" 
                            class="btn btn-dark"><b>Processing...</b></button>

                        <button v-else @click="campaignStore.finallyReAddEmpployeeToTeams"
                            class="btn btn-dark"><b>Add</b></button>


                    </div>





                </div>
            </div>
        </div>





    </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import TeamService from "@/services/TeamService";
import { useCampaignStore } from "@/stores/CampaignStore";
import { useTeamStore } from "@/stores/TeamStore";
import { onMounted, ref, computed } from 'vue';


const campaignStore = useCampaignStore();
const teamStore = useTeamStore();

const searchQuery = ref('');

const displayedEmployeesCount = ref(25); // Start with displaying 5 teams
const incrementStep = 15; //


const teamQuery = ref('');


const filteredEmployees = computed(() => {

    return campaignStore.employees
        .filter(emp => emp.name.toLowerCase().includes(searchQuery.value.toLowerCase()))
        .slice(0, displayedEmployeesCount.value);

});

const loadMoreEmp = () => {
    displayedEmployeesCount.value += incrementStep;
};


const softDeleteThisEmployeeCompletely = () => {

    const formData = {
        user_id: teamStore.currentEmployee.id
    }

    TeamService.deleteEmployeeCompletelyAcrossAllApps(formData)
        .then(() => {

            // campaignStore.fetchAllEmployees()
            teamStore.closeShowDeleteEmployeeModal()

            // Remove the user_id from the campaignStore.employees array
            campaignStore.employees = campaignStore.employees.filter(
                emp => emp.id !== formData.user_id
            );


            // console.log(response.data)

        }).catch((err) => {

            console.log(err)

        });

    console.log('completely')


}



const filteredTeams = computed(() => {

    return campaignStore.teams
        .filter(team => team.name.toLowerCase().includes(teamQuery.value.toLowerCase()))

});


onMounted(() => {

    campaignStore.fetchAllEmployees()
    teamStore.getAManagerAppAccessInfoForGroupTalk()

})



</script>

<style scoped>
.mainWrapper {
    /* background-color: aliceblue; */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.rightContentWrapper {
    /* overflow-y: auto; */
    width: 83%;
    display: flex;
    flex-direction: column;
}

.contentContainer {
    /* overflow-y: auto; */
    background-color: rgb(208, 28, 55);
    /* margin: 30px; */
    margin-top: 100px;
}

.rightColumns {
    /* display: flex;
  flex-direction: column; */
}

.topNav {
    background-color: blue;
}

.innerContainer {
    /* margin-top: 200px; */
    /* background-color: blueviolet; */
    overflow-y: auto;
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 100px;
}

.theHeaderWrapper {
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    /* background-color: aqua; */
}

.searchBarWrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    width: 100%;
    padding-bottom: 20px;
    /* background-color: rgb(22, 166, 37); */
}

.theBar {
    width: 350px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
}

.button-6 {
    align-items: center;
    /* background-color: #FFFFFF; */
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    display: inline-flex;
    font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    justify-content: center;
    line-height: 1.25;
    margin: 0;
    min-height: 3rem;
    padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
    position: relative;
    text-decoration: none;
    transition: all 250ms;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: baseline;
    width: auto;
}

.button-6:hover,
.button-6:focus {
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
    transform: translateY(-1px);
}

.button-6:active {
    background-color: #f0f0f1;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
    color: rgba(0, 0, 0, 0.65);
    transform: translateY(0);
}

.tableWrapper {
    margin-top: 20px;
    /* background-color: aqua; */
    width: 100%;
}

.my-custom-table tbody tr td {
    padding-top: 20px;
    /* Adjust the value as needed */
    padding-bottom: 20px;
    /* Adjust the value as needed */
}

.my-custom-table th {
    padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
    text-align: left;
    /* Aligns text to the left */
    padding-left: 20px;
    padding-right: 20px;
}

.campName {
    text-decoration: none;
    color: inherit;
}

.campName:hover {
    color: rgb(10, 159, 92);
    cursor: pointer;
    text-decoration: none;
}

.iconsRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.theActionIcon {
    font-weight: bolder;
    font-size: 18px;
    color: rgb(5, 2, 2);
    cursor: pointer;
}

.theActionIcon:hover {
    cursor: pointer;
    color: rgb(30, 158, 30);
    scale: 1.3;
    transition: 1s;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    z-index: 999;
    /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
    background-color: white;
    width: 1100px;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
    text-align: center;
}

.model-box-header {
    display: flex;
    justify-content: space-between;
    /* background-color: antiquewhite; */
    height: 40px;
    margin-bottom: 15px;
}

.form-control {
    background-color: rgb(243, 246, 246);
}

.createBTN {
    width: 100%;
    margin-top: 20px;
}

.noTeamBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 100%;
}

.noMatchBox {
    background-color: red;
    width: 100%;
}

.loadMoreBtn {
    background-color: black;
    border-radius: 10px;
}

.button-13 {
    background-color: #fff;
    border: 1px solid #d5d9d9;
    border-radius: 8px;
    box-shadow: rgba(213, 217, 217, 0.5) 0 2px 5px 0;
    box-sizing: border-box;
    color: #0f1111;
    cursor: pointer;
    display: inline-block;
    font-family: "Amazon Ember", sans-serif;
    font-size: 13px;
    line-height: 29px;
    padding: 0 10px 0 11px;
    position: relative;
    text-align: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: middle;
    min-width: 100px;
}

.button-13:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.activeSpan {
    background-color: #a7dda58c !important;
    color: black;
}

.innerBox {
    /* background-color: red; */
    overflow-y: auto;
    width: 100%;
    height: 500px;
    padding: 12px;
}


.talkItem {
    display: flex;
    flex-direction: row;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
    margin-bottom: 25px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
}

.talkItem:hover {
    background-color: rgb(249, 253, 252);
}

.talkLeft {
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 80%;
    /* background-color: #aadada; */
}

.talkRight {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    /* padding: 10px; */
    /* background-color: #3ddbdb; */
}

.talkTitle {
    /* background-color: #d9e7ff; */
    text-align: left;
    font-weight: bold;
    padding: 6px;
}


.groupActionBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* background-color: gray; */
}
</style>